export const useLoginRedirect = () => {
  const route = useRoute()
  const { locale } = useI18n()

  // Obtener la URL de redirección del query parameter o usar la URL actual
  const getRedirectUrl = (): string | undefined => {
    const redirect = route.query.redirect as string
    if (redirect) {
      return decodeURIComponent(redirect)
    }
    
    // Si estamos en una página de login, no redirigir a ella misma
    if (route.path.includes('/login') || route.path.includes('/register')) {
      return undefined
    }
    
    return route.fullPath
  }

  // Manejar la redirección después del login exitoso
  const handleLoginSuccess = (successCallback?: () => void) => {
    const redirectUrl = route.query.redirect as string
    
    if (redirectUrl) {
      const decodedUrl = decodeURIComponent(redirectUrl)
      navigateTo(decodedUrl)
    } else {
      navigateTo(`/${locale.value}/user-zone`)
    }
    
    if (successCallback) {
      successCallback()
    }
  }

  return {
    getRedirectUrl,
    handleLoginSuccess
  }
} 